import ConfirmDialog from './ConfirmDialog';
import AlertDialog from './AlertDialog';

// there may be other flavors in the future
export { AlertDialog, ConfirmDialog };



// WEBPACK FOOTER //
// ./src/ui/library/Dialog/index.js